import { TextField, Box } from '@mui/material';
import BaseModal from '../../../../Modal/BaseModal';
import { AddTemplateDialogProps } from './types';
import { useAddTemplateDialog } from './useAddTemplateDialog';
import './AddTemplateDialog.scss';

export const AddTemplateDialog = ({
  open,
  onClose,
  onSubmit,
}: AddTemplateDialogProps) => {
  const {
    templateName,
    setTemplateName,
    validationError,
    handleSubmit,
    handleClose,
  } = useAddTemplateDialog();

  // Handle dialog close
  const handleDialogClose = (): void => {
    handleClose();
    onClose();
  };

  // Handle form submission
  const handleFormSubmit = (): void => {
    const success = handleSubmit();

    if (success) {
      onSubmit(templateName);
      handleDialogClose();
    }
  };

  // Handle Enter key press
  const handleKeyPress = (event: React.KeyboardEvent): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleFormSubmit();
    }
  };

  // Determine if submit button should be disabled
  const isSubmitDisabled = !templateName.trim() || !!validationError;

  return (
    <BaseModal
      dataTestId="add-template-dialog"
      open={open}
      onClose={handleDialogClose}
      title="Add New Template"
      maxWidth="sm"
      submitText="Create"
      cancelText="Cancel"
      onSubmit={handleFormSubmit}
      submitDisabled={isSubmitDisabled}
    >
      <Box sx={{ pt: 1 }}>
        <TextField
          autoFocus
          fullWidth
          label="Template Name"
          value={templateName}
          onChange={e => setTemplateName(e.target.value)}
          onKeyPress={handleKeyPress}
          error={!!validationError}
          helperText={validationError}
          placeholder="Enter template name (e.g., Vaults, Danel)"
          inputProps={{
            maxLength: 50,
          }}
        />
      </Box>
    </BaseModal>
  );
};
